import {
  SASBOSS_ENTERPRISES_LOADING,
  SASBOSS_ENTERPRISES_LOADED,
  SASBOSS_ENTERPRISES_FAILED,
  SASBOSS_ENTERPRISE_UPDATING,
  SASBOSS_ENTERPRISE_UPDATED,
  SASBOSS_ENTERPRISE_UPDATE_FAILED,
  SASBOSS_SYNC_TRIGGERING,
  SASBOSS_SYNC_TRIGGERED,
  SASBOSS_SYNC_TRIGGER_FAILED,
} from '../components/actions/sasbossDidTypes'

const initialState = {
  loading: true,
  enterprises: [],
  updatingEnterpriseId: null,
  syncTriggering: false,
  lastSyncJobId: null,
}

const sasbossDidReducer = (state = initialState, action) => {
  switch (action.type) {
    case SASBOSS_ENTERPRISES_LOADING:
      state.loading = true
      return state
    case SASBOSS_ENTERPRISES_LOADED:
      state.loading = false
      state.enterprises = action.payload
      return state
    case SASBOSS_ENTERPRISES_FAILED:
      state.loading = false
      return state

    case SASBOSS_ENTERPRISE_UPDATING:
      state.updatingEnterpriseId = action.payload
      return state
    case SASBOSS_ENTERPRISE_UPDATED:
      state.updatingEnterpriseId = null
      return state
    case SASBOSS_ENTERPRISE_UPDATE_FAILED:
      state.updatingEnterpriseId = null
      return state

    case SASBOSS_SYNC_TRIGGERING:
      state.syncTriggering = true
      return state
    case SASBOSS_SYNC_TRIGGERED:
      state.syncTriggering = false
      state.lastSyncJobId = action.payload?.jobId
      return state
    case SASBOSS_SYNC_TRIGGER_FAILED:
      state.syncTriggering = false
      return state

    default:
      return state
  }
}

export default sasbossDidReducer
